import { Routes } from '@angular/router';

export const AppRoutes: Routes =[
    {path: '', loadChildren: './modules/modules.module#ModulesModule'},
    {path: '**', redirectTo: '', pathMatch: 'full'}
  ];
  
